import { render } from "./modal_ca_frs_clients.vue?vue&type=template&id=4176fefe&scoped=true"
import script from "./modal_ca_frs_clients.vue?vue&type=script&lang=js"
export * from "./modal_ca_frs_clients.vue?vue&type=script&lang=js"

import "./modal_ca_frs_clients.vue?vue&type=style&index=0&id=4176fefe&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4176fefe"]])

export default __exports__